import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import GithubIcon from "@material-ui/icons/GitHub";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home">
      <div className="about">
        <h2> Hi, My Name is Saurav Kumar</h2>
        <div className="prompt">
          <p style={{fontSize:"20px"}}>
            A software enthusiast, willing to work passionately on a given
            project, and gain valuable learning experience in competitive
            environment as an intern or full time
          </p>
          <a href="https://www.linkedin.com/in/saurav-kumar-b57ab318b/">
            <LinkedInIcon />
          </a>
          <a href="mailto:sauravbusiness02@gmail.com">
            <EmailIcon />
          </a>
          <a href="https://github.com/sauravkumar02">
            <GithubIcon />
          </a>
        </div>
      </div>
      <div className="skills">
        <h1> Skills</h1>
        <ol className="list">
          <li className="item">
            <h2> Front-End</h2>
            <span>
              ReactJS, Redux, HTML, CSS, React Native, NPM, Ionic, BootStrap,
              MaterialUI
            </span>
          </li>
          <li className="item">
            <h2>Back-End</h2>
            <span>ExpressJS, PHP, MySQL, MongoDB, API, Bot</span>
          </li>
          <li className="item">
            <h2>Languages</h2>
            <span>JavaScript, Java, C, </span>
          </li>
          <li className="item">
            <h2>Tools</h2>
            <span>VS Code, Git, Postman, Excel, IntelliJ IDEA, Botpress, Docker </span>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Home;
